import React, { useState } from "react";

// material components
import Divider from "@material-ui/core/Divider";
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import SpeakerNotesIcon from '@material-ui/icons/SpeakerNotes';
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import { Button, IconButton, MenuItem, Select, TextField, Tooltip, Typography } from "@material-ui/core";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import TableCell from "@material-ui/core/TableCell";
import green from "@material-ui/core/colors/green";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TableHead from "@material-ui/core/TableHead";
import { KeyboardDatePicker } from "@material-ui/pickers";


// constants
import {
    ADD_PO_ENTRY, CANCEL, CREATE_PO_CELLS_PRICING_ROLE,
    CREATE_PURCHASE_ORDERS_CELLS,
    NOTES, PREVIEW
} from "./constants";

// styling
import './CreatePurchaseOrderTable.css';
import PropTypes from "prop-types";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import { Document, Page } from "react-pdf";
import Box from "@material-ui/core/Box";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import { CARRIER_MISSING_ERROR, ERROR } from "../shipments/constants";
import FeedbackBar from "../feedbackBar/FeedbackBar";
import InputAdornment from "@material-ui/core/InputAdornment";


class CreatePurchaseOrderTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pageInit: true,
            showPreview: false,
            pageNumber: 1,
            numPages: null,
        };
    }

    onDocumentLoadSuccess = ({ numPages }) => {
        if (!this.state.numPages) {
            this.setState({
                numPages: numPages
            });
        }
    }

    InvalidDate() {
        if (this.props.editingPurchaseOrder) {
            return false;
        }
        let today = new Date()
        today.setHours(0, 0, 0, 0)
        let date = this.props.expectedDate
        date.setHours(0, 0, 0, 0)
        return date < today
    }

    handlePreview = () => {
        this.props.changeHeader("previewCreating")
        this.props.previewPDF()
    }

    displayAccountNumber = (selectedLocation, selectedSupplierInfo) => {
        let matchingAccount = selectedSupplierInfo?.accounts?.find((account)=>
            account?.location?.shipAddressId === selectedLocation.shipAddressId
        )
        return matchingAccount?.accountNumber || ""
    }

    isDuplicatedShortcode = (shortcode, index) => {
        if (!shortcode) return false

        return this.props.entries.some(
            (entry, i) =>
                i < index && entry.shortcode === shortcode
        )
    }

    render() {
        return (
            <>
                <Paper className="paper">
                    <TableContainer>
                        {/*Dropdown to select the supplier*/}
                        <br />
                        <div className="wrap">
                            <div className="supplier-select">
                                <Autocomplete
                                    options={this.props.editingPurchaseOrder && this.props.purchaseOrder.status == 'partial' ? [] : this.props.availableSupplierNames}
                                    getOptionLabel={(entry) => entry}
                                    autoHighlight={!this.props.editingPurchaseOrder}
                                    value={this.props.selectedSupplier}
                                    onChange={(event, value) => {
                                        if ((this.props.editingPurchaseOrder && this.props.purchaseOrder?.status !== 'partial') || !this.props.editingPurchaseOrder) {
                                            this.props.onSupplierChange(value ? value : "")
                                            this.setState({
                                                pageInit: false
                                            });
                                        }
                                    }
                                    }
                                    blurOnSelect={true}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            label="Supplier Name"
                                            InputLabelProps={{ shrink: true, readOnly: this.props.editingPurchaseOrder && this.props.purchaseOrder.status == 'partial' }}
                                            variant="outlined"
                                            autoFocus={this.state.pageInit}
                                            name="supplier"
                                            onChange={() => { }}

                                        />
                                    }
                                />
                            </div>
                            <Autocomplete
                                className="location-field"
                                options={this.props.editingPurchaseOrder && this.props.purchaseOrder.status == 'partial' ? [] : this.props.locations.filter(location => location.enabled)}
                                getOptionLabel={(entry) => entry.name}
                                autoHighlight={true}
                                // style={{width: 278, marginLeft: 28, marginBottom: 10}}
                                disableClearable
                                onChange={(event, value) => {
                                    return this.props.editingPurchaseOrder && this.props.purchaseOrder.status == 'partial' ? null : this.props.handleLocationChange(value, true)
                                }}
                                blurOnSelect={true}
                                value={this.props.selectedLocation}

                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        label="Ship To"
                                        InputLabelProps={{ shrink: true, readOnly: this.props.editingPurchaseOrder && this.props.purchaseOrder.status == 'partial' }}
                                        variant="outlined"
                                        name="location"
                                    />
                                }
                            />
                            <TextField
                                style={{marginRight: '10px', width: '150px'}}
                                variant="outlined"
                                name="accountNumber"
                                label="Account Number"
                                value={this.displayAccountNumber(this.props.selectedLocation,this.props.selectedSupplierInfo)}
                                size="medium"
                                disabled={true}
                                InputLabelProps={{shrink: true}}
                            />
                            <TextField
                                style={{marginRight: '10px', width: '150px'}}
                                error={(isNaN(Number(this.props.taxPercentage)) || this.props.taxPercentage === "")}
                                variant="outlined"
                                name="taxPercentage"
                                label="Tax Percentage"
                                value={this.props.taxPercentage}
                                onChange={(e) => this.props.handleTaxChange(e.target.value)}
                                size="medium"
                                InputLabelProps={{shrink: true}}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            %
                                        </InputAdornment>
                                    )
                                }}
                            />
                            <TextField
                                style={{width: '150px'}}
                                error={(isNaN(Number(this.props.discountPercentage)) || this.props.discountPercentage === "") && this.props.discountPercentage !== ""}
                                variant="outlined"
                                name="discountPercentage"
                                label="Discount"
                                value={this.props.discountPercentage}
                                onChange={(e) => this.props.handleDiscountChange(e.target.value)}
                                size="medium"
                                InputLabelProps={{shrink: true}}
                                error={!this.props.discountPercentage||this.props.discountPercentage==""}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            %
                                        </InputAdornment>
                                    )
                                }}
                            />
                            <div className="pick-date">
                                <KeyboardDatePicker
                                    autoOk
                                    error={this.InvalidDate()}
                                    helperText={this.InvalidDate() ? "Invalid Expected Delivery Date" : ""}
                                    variant="inline"
                                    inputVariant="outlined"
                                    label="Expected Delivery Date"
                                    format="MM/dd/yyyy"
                                    value={this.props.expectedDate}
                                    InputAdornmentProps={{ position: "start" }}
                                    onChange={date => this.props.handleDateChange(date)}
                                />
                            </div>
                            <div className="notes">
                                <Tooltip title={NOTES}>
                                    <IconButton
                                        aria-label='delete'
                                        onClick={this.props.showNotes}
                                    >
                                        <SpeakerNotesIcon />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        </div>
                        <Table
                            aria-labelledby="tableTitle"
                            size='small'
                            aria-label={this.props.title}
                        >
                            <TableHead>
                                <TableRow className="table">
                                    <TableCell className="add-delete-col" />
                                    {this.props.hasPricingRole ? CREATE_PO_CELLS_PRICING_ROLE.map((headCell) => (
                                        <TableCell key={headCell.id} className={headCell.id}
                                            style={{ textAlign: "center" }}>
                                            {headCell.label}
                                        </TableCell>
                                    )) : CREATE_PURCHASE_ORDERS_CELLS.map((headCell) => (
                                        <TableCell key={headCell.id} className={headCell.id}
                                                   style={{ textAlign: "center" }}>
                                            {headCell.label}
                                        </TableCell>
                                    ))
                                    }
                                </TableRow>
                            </TableHead>
                            <TableBody key={this.props.key}>
                                {/*Initial table row that will show up by default*/}
                                {this.props.entries?.map((row, index) => {
                                    const isDuplicate = this.isDuplicatedShortcode(row.shortcode, index)
                                    return (
                                        <TableRow>
                                            {row.deleteEntry ? <TableCell>
                                                <>
                                                    <IconButton onClick={() => this.props.removeEntry(index)}>
                                                        <RemoveCircleIcon
                                                            fontSize='small'
                                                            color='error'
                                                        />
                                                    </IconButton>
                                                </>
                                            </TableCell> : <TableCell></TableCell>}

                                            <TableCell style={{ textAlign: "center" }}>
                                                {/*Dropdown to select the shortcode which auto populates everything*/}
                                                <Autocomplete
                                                    options={this.props.availableProducts ? this.props.availableProducts.sort((a, b) => {
                                                        return a.toLowerCase().localeCompare(b.toLowerCase())
                                                    }) : []}
                                                    getOptionLabel={(entry) => entry}
                                                    // style={{ width: 215 }}
                                                    className="shortcode-field"
                                                    autoHighlight={true}
                                                    blurOnSelect={false}
                                                    value={row.shortcode}
                                                    onChange={(event, value) => this.props.onShortcodeChange(value, index)}
                                                    renderInput={(params) =>
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            autoFocus={!this.state.pageInit}
                                                            name="shortcode"
                                                            InputLabelProps={{ shrink: true }}
                                                            error={isDuplicate}
                                                            helperText={
                                                                isDuplicate ? "Duplicate Shortcode" : ""
                                                            }
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                            <TableCell style={{ textAlign: "center" }} className="center partnum-cell">
                                                {row.partNum}
                                            </TableCell>
                                            <TableCell style={{ textAlign: "left" }}>
                                                {row.description}
                                            </TableCell>
                                            {this.props.hasPricingRole ? <TableCell style={{textAlign: "center"}} className="pricing-cell">
                                                    <TextField
                                                        error={(isNaN(Number(row.price)) || row.price === "") && row.shortcode !== ""}
                                                        variant="outlined"
                                                        name="price"
                                                        value={row.price}
                                                        onChange={(e) => this.props.onChange(e, index)}
                                                        size="small"
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    $
                                                                </InputAdornment>
                                                            )
                                                        }}
                                                        onBlur={(e) => this.props.formatPrice(e.target.value, index)}
                                                    />
                                            </TableCell> : null}
                                            <TableCell style={{textAlign: "center"}} className="discount-cell">
                                                <TextField
                                                    error={(isNaN(Number(row.discount)) || row.discount === "") && row.discount !== ""}
                                                    variant="outlined"
                                                    name="discount"
                                                    value={row.discount}
                                                    onChange={(e) => this.props.onChange(e, index)}
                                                    size="small"
                                                    error={!row.discount||row.discount==""}
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                %
                                                            </InputAdornment>
                                                        )
                                                    }}
                                                />
                                            </TableCell>
                                            <TableCell style={{textAlign: "center"}} className="quantity-cell">
                                                <TextField
                                                    type="number"
                                                    variant="outlined"
                                                    name="skid"
                                                    value={row.skid}
                                                    onChange={(e) => this.props.onChange(e, index)}
                                                    size="small"
                                                />
                                            </TableCell>
                                            <TableCell style={{textAlign: "center"}} className="quantity-cell">
                                                <TextField
                                                    error={row.quantity === ""}
                                                    type="number"
                                                    variant="outlined"
                                                    name="quantity"
                                                    value={row.quantity}
                                                    onChange={(e) => this.props.onChange(e, index)}
                                                    size="small"
                                                />
                                            </TableCell>
                                        </TableRow>
                                    )
                                })}
                                <TableRow>
                                    <TableCell className='check'>
                                        <Tooltip placement="left" title={ADD_PO_ENTRY}>
                                            <IconButton onClick={this.props.addEntry}>
                                                <AddCircleIcon
                                                    fontSize="small"
                                                    color='secondary'
                                                />

                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {/*
                    <br/>

                    <div className='cancel-preview-buttons'>
                        <Button
                            className="cancel-button"
                            onClick={this.props.handleCancel}
                            variant="contained"
                        >
                            {CANCEL}
                        </Button>
                        <Button
                            onClick={this.handlePreview}
                            variant="contained"
                            color='primary'
                            className="preview-button"
                        >
                            {PREVIEW}
                        </Button>
                    </div>

                    <br/>*/}
                </Paper>
            </>
        );
    }
};

CreatePurchaseOrderTable.propTypes = {
    supplierInfo: PropTypes.array,
    selectedSupplier: PropTypes.string,
    availableProducts: PropTypes.array,
    availableSupplierNames: PropTypes.array,
    pdfData: PropTypes.array,
    openPreview: PropTypes.bool,
    entries: PropTypes.array,
    numRows: PropTypes.number,
    addEntry: PropTypes.func,
    removeEntry: PropTypes.func,
    onShortcodeChange: PropTypes.func,
    onSupplierChange: PropTypes.func,
    onNotesChange: PropTypes.func,
    onChange: PropTypes.func,
    tableKey: PropTypes.number,
    handleDateChange: PropTypes.func,
    expectedDate: PropTypes.number,
    showNotes: PropTypes.func,
    previewPDF: PropTypes.func,
    previewClose: PropTypes.func,
    handleSubmit: PropTypes.func,
    handleSendSubmit: PropTypes.func,
    handleCancel: PropTypes.func
}

CreatePurchaseOrderTable.defaultProps = {
    supplierInfo: [],
    selectedSupplier: '',
    availableProducts: [],
    availableSupplierNames: [],
    entries: [],
    numRows: 0,
    addEntry: () => {
    },
    removeEntry: () => {
    },
    onShortcodeChange: () => {
    },
    onSupplierChange: () => {
    },
    onNotesChange: () => {
    },
    onChange: () => {
    },
    tableKey: 0,
    handleDateChange: () => {
    },
    expectedDate: 0,
    showNotes: () => {
    },
    previewPDF: () => {
    },
    handleCancel: () => {
    }
}

export default CreatePurchaseOrderTable;